<template>
  <DBox
    :id="'cmp-booking-tasks-task_details-travels-box' + type"
    :addButton="false"
    :addLink="false"
  >
    <NTable
      class="dbox1"
      :id="'booking-tasks-task_details-travels-table-' + type"
      :headers="travelListHeaders"
      :items="travels"
      :config="tableConfig"
      :showNoItems="true"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('artist')">
            <span class="txtov td-inner" v-html="item['travellers']"></span>
          </td>
          <td v-bind="tdcon('itinerary')">
            <div class="itinerary-block">
              <span class="destination-block">
                <span class="line"></span>
              </span>
              <div class="keyvalue-container">
                <div class="keyvalue-item">
                  <div class="key">{{$t('from_string')}}</div>
                  <div class="txtov value" v-html="item['origin']"></div>
                </div>
                <div class="keyvalue-item">
                  <div class="key">{{$t('to_string')}}</div>
                  <div class="txtov value" v-html="item['destination']"></div>
                </div>
              </div>
            </div>
          </td>

          <td v-bind="tdcon('travel')">
            <span class="txtov" :title="item['travel_no']">
              {{ item["travel_no"] }}
            </span>
          </td>
          <td v-bind="tdcon('filekey')">
            <span class="txtov" v-html="item['booking_codes']"></span>
          </td>

          <td v-bind="tdcon('costs')" @click.stop>
            <span class="ut-jend">
              <span>
                {{ $dft.curr(item["costs"]) }}
                {{ $store.getters.account.client.default_currency }}
              </span>
            </span>
          </td>

          <td v-bind="tdcon('confirmed')">
            <div class="dt-checkbox v2 s1" :title="$t('confirm_travel')">
              <input
                type="checkbox"
                name="checkbox"
                id="checkbox"
                :checked="item['confirmed_flag'] == 1 ? true : false"
                disabled
              />
              <div class="checkmark"></div>
            </div>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>

<script>
import { createNTableConfig, createTableHeader } from "../../../../plugins/datatable";

export default {
  components: {
  },
  props: {
    type: {
      default: "before",
      type: String,
    },
    travels: {
      required: true,
      type: Array,
    }
  },
  data: function () {
    return {
    //   tableConfig: createNTableConfig({
    //     headerStyle: 3,
    //     headerHeight: 28,
    //     rowHeight: 32,
    //     fullHeight: true,
    //     footer: false,
    //   }),
    };
  },
  computed:{
    travelListHeaders: function () {
      return [
        createTableHeader("artist", { text: "Name" }),
        createTableHeader("itinerary", { text: "Itinerary", f: 3 }),
        createTableHeader("travel", { text: "Travel No." }),
        createTableHeader("filekey"),
        createTableHeader("costs", { text: "Costs", ta: "right" }),
        createTableHeader("confirmed", { mw: 84, ta: "center" }),
      ];
    },
    tableConfig(){
      return createNTableConfig({
        headerStyle: 3,
        headerHeight: 28,
        rowHeight: this.travels && this.travels.length > 0 ? 122: 32,
        fullHeight: true,
        footer: false,
      });
    }
  },
  methods: {

  },
};
</script>

<style lang="scss">
.booking-tasks-task_details-travels-table-before,
.booking-tasks-task_details-travels-table-after {
  // --ntable-height: 196px !important;
  --ntable-height: auto !important;
  td {
    justify-content: flex-start !important;
    &.costs,
    &.filekey,
    &.close,
    &.icon,
    &.confirmed {
      .ut-center,
      .dt-checkbox {
        margin: 0 auto !important;
      }
    }
    &.costs,
    &.filekey,
    &.close,
    &.icon {
      padding-top: 3px;
    }
    &.confirmed {
      padding-top: 9px;
    }
  }

  .itinerary-block {
    display: flex;
    .destination-block {
      display: block;
      flex: 0 1 12px;
      max-width: 12px;
      position: relative;

      &:before,
      &:after {
        content: "";
        position: absolute;
        left: 0;
        width: 12px;
        height: 12px;
        border-radius: 50%;
      }
      &:before {
        top: 8px;
        border: 2px solid #000;
      }
      &:after {
        top: 35px;
        background-color: #000;
      }

      .line {
        display: block;
        width: 1px;
        height: 20px;
        background-color: #000;
        margin: 19px auto 0;
      }
    }
    .keyvalue-container {
      flex: 1;
      padding-left: 12px;
    }
  }

  .keyvalue-container {
    display: flex;
    flex-direction: column;
    .keyvalue-item {
      display: flex;

      .value {
        margin: 0px 10px;
      }

      .key {
        margin: 0px;
        min-width: 30px;
        text-align: right;
      }
      .value {
        flex: 1;

        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
</style>
